import React from "react";
import "./footer.css";
import { useBrand } from "../../context/brand-context";

/* Logos */
import amenLogo from "../../images/amen.png";
import mgLogo from "../../images/MG2.png";
import { useNavigate, useLocation } from "react-router-dom";
/* Font Awesome 5 via react-icons */
import {
  FaMapMarkerAlt, FaPhoneAlt, FaEnvelope,
  FaFacebookF, FaInstagram, FaArrowRight,
} from "react-icons/fa";

export default function Footer() {
  const { brand } = useBrand();              // 'amen' | 'mg'
  const isAmen = brand === "amen";
  const logo = isAmen ? amenLogo : mgLogo;
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === "/";  // page d'accueil publique → les deux logos

  const scrollToProducts = () => {
    const doScroll = () => {
      const el = document.getElementById("products-section");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    if (location.pathname === "/" || location.pathname === "/espace") { doScroll(); return; }
    navigate("/espace", { replace: false });
    setTimeout(doScroll, 0);
  };

  return (
    <footer className="ft">
      <div className="ft__top">
        <div className="ft__container ft__grid">

          {/* Marque */}
          <div className="ft__brandCol">
            {isHome ? (
              <div className="ft__logos">
                <img src={amenLogo} alt="Amen Distribution" className="ft__logo" />
                <img src={mgLogo} alt="MG Distribution" className="ft__logo ft__logo--mg" />
              </div>
            ) : (
              <img src={logo} alt={isAmen ? "Amen Distribution" : "MG Distribution"} className="ft__logo" />
            )}
            <p className="ft__tagline">
              Grossiste B2B de pièces auto d'origine et adaptables en Tunisie.
              Recherche par VIN, prix revendeur et livraison 24 h partout dans le pays.
            </p>
            <div className="ft__socials">
              <a href="https://www.facebook.com/share/1DEoFXQrB2/?mibextid=wwXIfr"
                 target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://www.instagram.com/ste_amene_de_distribution?igsh=MWhtMGo0dDMyenFvMA=="
                 target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className="ft__col">
            <h4 className="ft__title">Navigation</h4>
            <ul className="ft__links">
              <li><a href="/espace">Accueil</a></li>
              <li><button type="button" onClick={scrollToProducts}>Produits</button></li>
              <li><a href="/espace">À propos</a></li>
              <li><a href="mailto:contact@amenedistribution.com">Contact</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="ft__col">
            <h4 className="ft__title">Contact</h4>
            <ul className="ft__contact">
              <li>
                <span className="ft__ic"><FaMapMarkerAlt /></span>
                <span>Saida Sidi Bouzid<br />9115 Tunis, Tunisie</span>
              </li>
              <li>
                <span className="ft__ic"><FaPhoneAlt /></span>
                <a href="tel:+21629310215">+216 29 310 215</a>
              </li>
              <li>
                <span className="ft__ic"><FaPhoneAlt /></span>
                <a href="tel:+21629310729">+216 29 310 729</a>
              </li>
              <li>
                <span className="ft__ic"><FaEnvelope /></span>
                <a href="mailto:contact@amenedistribution.com">contact@amenedistribution.com</a>
              </li>
            </ul>
          </div>

          {/* Appel à l'action */}
          <div className="ft__col ft__ctaCol">
            <h4 className="ft__title">Espace revendeur</h4>
            <p className="ft__ctaText">Accédez au catalogue complet et à vos prix professionnels.</p>
            <a href="/login" className="ft__cta">Accéder <FaArrowRight /></a>
          </div>

        </div>
      </div>

      <div className="ft__bottom">
        <div className="ft__container ft__bottomInner">
          <span>© {new Date().getFullYear()} Amen Distribution — Tous droits réservés.</span>
          <span className="ft__muted">Pièces auto &amp; pièces de rechange B2B · Tunisie</span>
        </div>
      </div>
    </footer>
  );
}
